export default "__VITE_ASSET__tQmy64nW__"